import locales from './locales';

export const getQuotaWarningLocale = (
  freeCardsIncluded: number,
  freeCardsLeft: number,
): string => {
  if (freeCardsIncluded === 0) {
    return locales.quotaWarning.noneInQuota;
  }
  if (freeCardsLeft <= 0) {
    return locales.quotaWarning.zeroLeft;
  }
  if (freeCardsLeft === 1) {
    return locales.quotaWarning.oneLeft;
  }
  return locales.quotaWarning.multipleLeft;
};
